import {debugMode} from "../../helpers/config";


export const logger = (state, dispatch, action) => {
    if(!debugMode) {
        return
    }
    console.log(state)
    console.log(dispatch)
    console.log(action)
}